export const INITIALIZE_SIGN_IN = 'initialize-sign-in';

const initializeSignIn = () => (
  { type: INITIALIZE_SIGN_IN }
);
export default initializeSignIn;
